module.exports = __webpack_public_path__ + "img/icon_flag.492e4ef5.svg";